import React from 'react';
import { svgStyles, sizes, colors } from './styles';
import { ThemeProvider } from 'baseui';
import { IIcon } from './types';
import { ICONS } from './svg';
import { Icon as SvgIcon } from './view';
import { Theme } from '../../../Themes/themeProvider/ThemeProvider';
import { useStyletron } from '../../../Themes';

export const Icon: React.FC<IIcon> = (props: IIcon) => {
	const svgOptions = svgStyles(props);

	return (
		<ThemeProvider theme={Theme}>
			{props.icon && ICONS.hasOwnProperty(props.icon) && (
				//TODO: Review paddings icon + text
				<span style={svgOptions.iconStyles}>
					<SvgIcon
						for={props.for}
						icon={props.icon as keyof typeof ICONS}
						color={props.color || svgOptions.iconColor}
						size={props.size || svgOptions.iconSize}
					/>
				</span>
			)}
		</ThemeProvider>
	);
};

export const _MIcon = React.forwardRef((props: IIcon, ref: any) => {
	const { size = 'small', color = 'inherit', icon, className, ...rest } = props;

	const defaultIcon = `epo-icons icon-${icon}`;
	const cssClassName = className ? `${className} epo-icons icon-${icon}` : defaultIcon;

	const isPresetSize = ['x-small', 'small', 'medium', 'large', 'x-large'].includes(size);
	const sizeDefinition = isPresetSize ? sizes[size] : size;

	const isPresetColor = ['validated', 'error', 'warning', 'information'].includes(color);
	const colorDefinition = isPresetColor ? colors[color] : color;

	return (
		<i
			ref={ref}
			className={cssClassName}
			style={{
				...{
					fontSize: sizeDefinition,
					width: sizeDefinition,
					height: sizeDefinition,
					MinWidth: sizeDefinition,
					MinHeight: sizeDefinition,
					MaxWidth: sizeDefinition,
					MaxHeight: sizeDefinition,
					boxSizing: 'content-box',
					color: colorDefinition,
				},
				...props.style,
			}}
			{...rest}
		/>
	);
});

export const MIcon = React.memo(_MIcon);

export const NoIcon = React.forwardRef((props: any, ref: any) => {
	const { size = '18px', color, style, className, ...rest } = props;
	const [css] = useStyletron();

	const isPresetSize = ['x-small', 'small', 'medium', 'large', 'x-large'].includes(size);
	const sizeDefinition = isPresetSize ? sizes[size] : size;

	return (
		<span
			ref={ref}
			aria-hidden="true"
			className={`${className} ${css({
				...{
					width: sizeDefinition,
					height: sizeDefinition,
					MinWidth: sizeDefinition,
					MinHeight: sizeDefinition,
					MaxWidth: sizeDefinition,
					MaxHeight: sizeDefinition,
					boxSizing: 'content-box',
				},
				...style,
			})}`}
			{...rest}
		></span>
	);
});
